import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, SvgIcon } from '@gik/ui';
import moment, { Moment } from 'moment';
import noop from '@gik/core/utils/noop';

export interface ICalendarBarProps extends React.HTMLAttributes<HTMLDivElement> {
  selectedMonth?: string;
  onNext?(): void;
  onPrev?(): void;
}

export default function CalendarBar({
  selectedMonth,
  className,
  onPrev = noop,
  onNext = noop,
  ...otherProps
}: ICalendarBarProps): React.ReactElement {
  const bem = bemBlock('calendar-bar');

  const [monthName, setMonthName] = React.useState<string>();
  const [prevMonthName, setPrevMonthName] = React.useState<string>();
  const [nextMonthName, setNextMonthName] = React.useState<string>();

  React.useEffect(() => {
    setDate(moment(selectedMonth));
  }, [selectedMonth]);

  function setDate(date: Moment) {
    if (!date) return;

    setMonthName(date.format('MMMM YYYY'));
    setPrevMonthName(date.clone().add(-1, 'month').format('MMM'));
    setNextMonthName(date.clone().add(1, 'month').format('MMM'));
  }

  return (
    <div className={bem(null, null, className)} {...otherProps}>
      <Button
        squared
        onClick={onPrev}
        className={bem('btn-prev')}
        prepend={<SvgIcon size="sm" name="ChevronLeftOutline" />}
      >
        {prevMonthName}
      </Button>
      <div className={bem('title')}>{monthName}</div>
      <Button
        squared
        onClick={onNext}
        className={bem('btn-next')}
        append={<SvgIcon size="sm" name="ChevronRightOutline" />}
      >
        {nextMonthName}
      </Button>
    </div>
  );
}
